'use strict'

import VectorClick from '@/components/vue-map/interactions/vectorClick'
import DrawInteraction from '@/components/vue-map/interactions/drawInteraction'

// NOTE
// Les states avec un _ doivent être accédés via des getters
// Les mutations avec un _ doivent être appelées uniquement depuis des actions

export default {
  state: {
    vectorClickInteraction: null,
    elevationProfilInteraction: null
  },
  getters: {
    interactions (state) {
      let toReturn = []
      if (state.vectorClickInteraction !== null) toReturn.push(state.vectorClickInteraction)
      if (state.elevationProfilInteraction !== null) toReturn.push(state.elevationProfilInteraction)
      return toReturn
    }
  },
  mutations: {
    _initVectorClickInteraction (state, mapRef) {
      if (state.vectorClickInteraction !== null) state.vectorClickInteraction.release()

      state.vectorClickInteraction = new VectorClick({
        map: mapRef
      })
    },
    initElevationProfilInteraction (state, mapRef) {
      if (state.elevationProfilInteraction !== null) state.elevationProfilInteraction.release()

      state.elevationProfilInteraction = new DrawInteraction({
        map: mapRef,
        drawType: 'LineString',
        maxPoints: 2
      })
    }
  },
  actions: {
    initInteractions ({ commit }, mapRef) {
      commit('_initVectorClickInteraction', mapRef)
    }
  }
}
